import { useState } from "react";
import { useNavigate } from "react-router";
import { useCookies } from "react-cookie";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Authorization from "../models/Authorization.tsx";

interface Props {
  isAdministrator: boolean
}

const Login = ({ isAdministrator }: Props) => {
  const { authorization, SetAuthorization } = useAuth();

  const NewCredentials = () => {
    const credentials = {
      DesignationNumber: "",
      Password: "",
      IsAdministrator: isAdministrator
    }
    return credentials;
  }

  const navigate = useNavigate();
  const [credentials, SetCredentials] = useState(NewCredentials());
  const [success_reset, SetResetSuccess] = useState(false);
  const [success_passcode, SetPasscodeSuccess] = useState(false);
  const [error_login, SetLoginError] = useState(false);
  const [error_passcode, SetPasscodeError] = useState(false);
  const [mode, SetMode] = useState(0);
  const [designationNumber, SetDesignationNumber] = useState("");
  const [passcode, SetPasscode] = useState("");
  const [businessId, SetBusinessId] = useState(0);
  const [cookies, SetCookie] = useCookies(["Token"]);

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    if (name === "Reset") {
      SetDesignationNumber(value);
    } else if (name === "Passcode") {
      SetPasscode(value);
    } else {
      SetCredentials((prevState) => ({ ...prevState, [name]: value }));
    }
  }

  const SubmitLogin = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials)
    };

    fetch("/api/login", options)
      .then(response => response.text())
      .then(data => {
        const businessId: number = parseInt(data);
        if (businessId === 0) {
          SetLoginError(true);
          return;
        } else {
          SetBusinessId(businessId);
        }
        
        SetPasscodeSuccess(true);
        SetMode(1);
      })
      .catch(error => console.error(error));
  }

  const SubmitAuthentication = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    var values = {
      BusinessId: businessId,
      Code: passcode
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values)
    };

    fetch("/api/authentication", options)
      .then(response => response.text())
      .then(data => {
        const token: string = data;
        if (token === "") {
          SetPasscodeError(true);
          return;
        }
        
        SetCookie("Token", token, { path: "/" });

        fetch("/api/business?token=" + token)
          .then(response => response.json())
          .then(data => {
            const business = data;
            var isComplete = business.OperatingName &&
              business.LegalName &&
              business.Address &&
              business.City &&
              business.PostalCode &&
              business.OperatingSectorId &&
              business.BusinessSizeId &&
              business.YearsOfOperationId &&
              business.FirstName &&
              business.LastName &&
              business.Email &&
              business.Telephone &&
              business.IsTermsAndConditions;
            const current: Authorization = {
              Token: token,
              DesignationNumber: business.DesignationNumber,
              IsAdministrator: business.IsAdministrator,
              IsComplete: isComplete
            };
            SetAuthorization(current);

            // Redirect administrative users
            if (business.IsAdministrator) {
              navigate("/admin/profiles");
            }
            
            // Redirect conventional users based on profile completeness
            if (!business.IsAdministrator) {
              if (!isComplete) {
                navigate("/profile");
              } else {
                navigate("/applications");
              }
            }
          })
      })
      .catch(error => console.error(error));
  }  

  const SubmitReset = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    fetch("/api/password?designationNumber=" + designationNumber)
      .then(response => response.text())
      .then(data => {
          SetResetSuccess(true);
          SetMode(0);
      })
      .catch(error => console.error(error));
  }

  return (
    <div className="login">
      <Snackbar open={success_reset} onClose={() => SetResetSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="success" variant="filled" sx={{ width: "100%", padding: 2 }}>
          An email containing instructions on how to reset your password has been sent.
        </Alert>
      </Snackbar>

      <Snackbar open={success_passcode} onClose={() => SetPasscodeSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="success" variant="filled" sx={{ width: "100%", padding: 2 }}>
          An email containing your authentication passcode has been sent.
        </Alert>
      </Snackbar>      

      <Snackbar open={error_login} onClose={() => SetLoginError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Designation number and password do not match an active account.
        </Alert>
      </Snackbar>

      <Snackbar open={error_passcode} onClose={() => SetPasscodeError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Authorization code is invalid or has expired.
        </Alert>
      </Snackbar>      

      <header>
        <a href="#main" className="skip">Skip to main content</a>
        <div className="container">
            <div className="logo"><a href="/"><img src="/images/logo-login.jpg" alt="Rural Community Immigration Pilot Logo" /></a></div>
            <h1>RCIP {isAdministrator ? "Admin" : "Employer"} Portal Login</h1>  
        </div>
      </header>
      {mode === 0 &&
        <section id="main">
          <div className="container">
            <form onSubmit={SubmitLogin}>
              <p>
                <label>Designation Number
                  <input type="text" name="DesignationNumber" onChange={OnChange} required />
                </label>
              </p>
              <p>
                <label>Password
                  <input type="password" name="Password" onChange={OnChange} required />
                </label>    
              </p>
              <p className="formButton"><input type="submit" value="Login" /></p>
              <p className="formButton"><a onClick={()=> SetMode(2)}>Forgot Password?</a></p>
            </form>
          </div>
        </section>
      }
      {mode === 1 &&
        <section id="main">
          <div className="container">
            <form onSubmit={SubmitAuthentication}>
              <p>
                <label>Authentication Code
                  <input type="text" name="Passcode" onChange={OnChange} required maxLength={6} />
                </label>
              </p>
              <p className="formButton"><input type="submit" value="Enter Authentication Code" /></p>
              <p className="formButton"><a onClick={SubmitLogin}>Resend email containing authentication code</a></p>
              <p className="formButton"><a onClick={()=> SetMode(0)}>Return to Sign In</a></p>
            </form>            
          </div>
        </section>
      }      
      {mode === 2 &&
        <section id="main">
          <div className="container">
            <form onSubmit={SubmitReset}>
              <p>
                <label>Designation Number
                  <input type="text" name="Reset" onChange={OnChange} required />
                </label>
              </p>
              <p className="formButton"><input type="submit" value="Reset Password" /></p>
              <p className="formButton"><a onClick={()=> SetMode(0)}>Return to Sign In</a></p>
            </form>            
          </div>
        </section>
      }      
    </div>
  );
}

export default Login;